import { render, staticRenderFns } from "./index.vue?vue&type=template&id=61aef6fa"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61aef6fa')) {
      api.createRecord('61aef6fa', component.options)
    } else {
      api.reload('61aef6fa', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=61aef6fa", function () {
      api.rerender('61aef6fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CopyButton/index.vue"
export default component.exports